module.exports = __webpack_public_path__ + "static/img/gold.11f587e9.png";